export function tab() {
 const tabMenu = document.querySelectorAll(".c-tab__menuItem");
 const tabContent = document.querySelectorAll(".c-tab__contentItem");

 // 最初にすべて非表示にし、1つ目だけ表示
 tabContent.forEach((item, index) => {
  item.style.display = index === 0 ? "block" : "none";
 });

 tabMenu.forEach((tab, index) => {
  tab.addEventListener("click", function () {
   tabMenu.forEach((otherTab, otherIndex) => {
    otherTab.classList.remove("js-tab-active");
    tabContent[otherIndex].style.display = "none";
   });

   tab.classList.add("js-tab-active");
   tabContent[index].style.display = "block";

   // GSAPのアニメーション
   let img = tabContent[index].querySelector(":scope img");
   let p = tabContent[index].querySelector(":scope p");
   if (!img || !p) return;

   let tl = gsap.timeline({
    scrollTrigger: {
     trigger: tabContent[index],
     start: "top center",
    },
   });


  });
 });
}
